/**
 * @flow
 * */
import config from 'config';

import NetworkService from 'core/services/network/NetworkService';
import BaseSDK from 'core/sdk/BaseSDK';
import type { WithData } from 'types';
import type {
  ResolveAlertReviewParams,
  AlertReviewParams,
  AlertReviewModel
} from 'modules/LCRMT/Alerts/types';

/**
 * * @class AlertsSDK
 */
class AlertsSDK extends BaseSDK {
    _rmtApiService: NetworkService;

    constructor() {
      super();
      this._rmtApiService = new NetworkService(config.rmtApi);
    }

    /**
     * getAlertReview
     * @param {AlertReviewParams} params -
     * @returns {Promise<WithData<AlertReviewModel>>} -
     */
    async getAlertReview(params: AlertReviewParams): Promise<WithData<AlertReviewModel>> {
      const { alertId } = params;

      const { body } = await this._rmtApiService.makeAPIGetRequest(
        'LCRMTAlerts/ReviewChiSquareAlert',
        { query_params: { alertId } }
      );

      return {
        data: body.Data.ReviewResults
      };
    }

    /**
     * closeAlertReview
     * @param {AlertReviewParams} params -
     * @returns {Promise<WithData<any>>} -
     */
    async closeAlertReview(params: AlertReviewParams): Promise<WithData<any>> {
      const { alertId } = params;

      const { body } = await this._rmtApiService.makeAPIGetRequest(
        'LCRMTAlerts/CloseChiSquareAlertPopUp',
        { query_params: { alertId } }
      );

      return body.Data;
    }

    /**
     * resolveAlertReview
     * @param {AlertReviewParams} params -
     * @returns {null} -
     */
    async resolveAlertReview(params: ResolveAlertReviewParams): Promise<WithData<any>> {
      const { alertId, comment } = params;

      const { body } = await this._rmtApiService.makeAPIGetRequest(
        'LCRMTAlerts/CloseChiSquareAlert',
        { query_params: { alertId, comment } }
      );

      return body.Data;
    }

    /**
   * cancelAlertSDKCalls
   * @param {Object} params -
   * @returns {Object} -
   */
    cancelAlertSDKCalls(params: { name: string | Array<string> }): void {
      const { name } = params;
      this.abortCall(name);
    }
}

export default new AlertsSDK();
